import React, { useState } from "react";
import "../css/FAQ.css";

import questions from "../utils/questions";
import Question from "./cards/Question";

import decorationRight from "../images/decorations/counseling_decoration_2.png"
import decorationLeft from "../images/decorations/counseling_decoration_1.png";


import line from "../images/line.png";
import { useSelector } from "react-redux";

const FAQ = () => {

    const [active, setActive] = useState();
    const handleQuestionActive = (id) => {
        setActive(id);
    }

    const banner = useSelector((state) => state.banner.value.banner);
    const width = window.innerWidth <= 460 ? 150 : 40;

    const paddingTop = banner ? { paddingTop: width + 80 } : { paddingTop: 80 };

    return (
        <div className="FAQ" style={paddingTop}>
            <div className="faq-container container">
                <img
                    src={decorationRight}
                    alt="Decoration"
                    className="decoration-right"
                />
                <img
                    src={decorationLeft}
                    alt="Decoration"
                    className="decoration-left"
                />

                <div className="faq-title">
                    <h1>
                        PREGUNTAS{" "}
                        <span>
                            <img src={line} alt="underline" />
                            FRECUENTES
                        </span>
                    </h1>
                </div>
                <div className="faq-content">
                    <div className="faq-questions">
                        {questions.map((q, i) => (
                            <Question
                                key={q.id}
                                question={q.question}
                                answer={q.answer}
                                id={q.id}
                                handleQuestionActive={handleQuestionActive}
                                active={active === q.id ? true : false}
                            />
                        ))}
                        <a
                            href="https://calendly.com/libel"
                            target={"_blank"}
                            rel="noreferrer"
                            className="request-advice"
                        >
                            SOLICITAR ASESORÍA
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FAQ;
